import { FaWhatsapp } from "react-icons/fa";
import { useState } from "react";
import Popup from "../common/Popup";

const WhatsAppIcon = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const message = "Hi, I'd like help ordering medicines from MediSYS Pharmacy.";
  const encodedMessage = encodeURIComponent(message);

  const handleClick = () => {
    // const token = localStorage.getItem("authToken");
    // if (token) {
      window.open(
        `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}?text=${encodedMessage}`,
        "_blank",
      );
    // } else {
    //   setShowLoginPopup(true);
    // }
  };

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
        {/* Tooltip label — sits above button */}
        <div
          className="flex items-center gap-2 bg-[#162c2a] border border-white/[0.1] rounded-xl px-3 py-2 shadow-[0_4px_16px_rgba(22,44,42,0.3)] opacity-0 translate-y-1 pointer-events-none
          peer-hover:opacity-100 peer-hover:translate-y-0 transition-all duration-200"
        >
          <span className="text-[12px] font-semibold font-poppins text-white whitespace-nowrap">
            Chat with us on WhatsApp
          </span>
        </div>

        {/* WhatsApp button */}
        <button
          onClick={handleClick}
          className="peer group relative flex items-center justify-center w-[52px] h-[52px] rounded-full bg-[#25D366] hover:bg-[#1ebe5d] shadow-[0_4px_20px_rgba(37,211,102,0.45)] hover:shadow-[0_6px_28px_rgba(37,211,102,0.6)] transition-all duration-200 hover:-translate-y-1 hover:scale-105"
        >
          {/* Ping pulse ring */}
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />

          <FaWhatsapp size={26} className="relative z-10 text-white" />

          {/* Hover tooltip */}
          <span className="absolute bottom-full right-0 mb-3 bg-[#162c2a] border border-white/[0.1] text-white text-[11px] font-semibold font-poppins px-3 py-1.5 rounded-xl whitespace-nowrap shadow-[0_4px_14px_rgba(22,44,42,0.3)] opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-200 pointer-events-none">
            Chat with us · MediSYS Pharmacy
            {/* Tooltip arrow */}
            <span className="absolute top-full right-4 border-4 border-transparent border-t-[#162c2a]" />
          </span>
        </button>
      </div>

      {showLoginPopup && <Popup onClose={() => setShowLoginPopup(false)} />}
    </>
  );
};

export default WhatsAppIcon;
